/* import __COLOCATED_TEMPLATE__ from './prism-button.hbs'; */
import { or } from '@ember/object/computed';
import Component from '@ember/component';
import { computed } from '@ember/object';

/* *
 * PrismButton: a button with preset themes, sizes, and states.
 * Disables button when loading.
 *
 * @param {String} theme - One of:
 *   - 'primary'
 *   - 'secondary'
 *   - 'tertiary'
 *   - 'destructive'
 *   - 'icon'
 * @param {String} size - One of:
 *   - 'responsive' (default)
 *   - 'large'
 *   - 'small'
 *   - 'mini'
 * @param {Boolean} loading - Shows spinner and disables cursor. Default false.
 * @param {Boolean} disabled - Uses disabled theme and cursor. Default false.
 * @param {Action} onClick - Closure action for backwards compatability.
 *
 * Example:
 * ```
 *   <PrismButton
 *     id='button-id'
 *     @theme='secondary'
 *     @size='small'
 *     @loading=true
 *     @disabled=false
 *     @onClick={{action this.doSomething}} >
 *     Button Content
 *   </PrismButton>
 *
 *   {{#prism-button
 *     id='button-id'
 *     theme='secondary'
 *     loading=true
 *     disabled=false
 *     onClick=(action this.doSomething)}}
 *     Button Content
 *   {{/prism-button}}
 * ```
 */
export default Component.extend({
  tagName: 'button',
  attributeBindings: ['_isDisabled:disabled'],
  classNames: ['prism-button'],
  classNameBindings: ['_themeClassName', '_sizeClassName'],
  theme: 'primary',
  size: 'responsive',
  loading: false,
  disabled: false,
  onClick() {},
  _isDisabled: or('loading', 'disabled'),
  _themeClassName: computed('theme', 'disabled', function () {
    if (this.disabled) {
      return `prism-button--${this.theme}-disabled`;
    } else {
      return `prism-button--${this.theme}`;
    }
  }),
  _sizeClassName: computed('size', function () {
    return `prism-button--${this.size}`;
  }),
  click() {
    this.onClick();
  }
});